module.exports = __webpack_public_path__ + "img/goparity.871a5120.svg";